import { Buffer } from 'buffer';

if (typeof window !== 'undefined') {
  window.Buffer = window.Buffer || Buffer;
}
var isChina = function isChina() {
  var url = window.location.href;
  return url.indexOf('.cn') !== -1;
};
var debounce = function debounce(func, timer) {
  var action;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(action);
    action = setTimeout(function () {
      return func.apply(void 0, args);
    }, timer);
  };
};

// Decode the token to extract user details
var parseJwt = function parseJwt(token) {
  if (!token) return null;
  var base64Url = token.split('.')[1];
  if (!base64Url) {
    return null;
  }
  var base64String = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = Buffer.from(base64String, 'base64').toString('utf-8');
  return JSON.parse(jsonPayload);
};
var buildFilters = function buildFilters() {
  var filterOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _filterOptions$accoun = filterOptions.accountTypes,
    accountTypes = _filterOptions$accoun === void 0 ? [] : _filterOptions$accoun;
  var defaultFilter = {
    is_active: ['true']
  };
  if (accountTypes.length) {
    defaultFilter.account_type = accountTypes;
  }
  return defaultFilter;
};
var buildTypeAheadQuery = function buildTypeAheadQuery(term, skip, limit, filterOptions, scope) {
  var _Object$keys;
  var filters = buildFilters(filterOptions);
  var newScope = scope;
  if (scope === 'all') newScope = false;
  var queryOperation = "{\n          globalSearch(term:\"".concat(term, "\",").concat(newScope ? "context:[".concat(newScope, "],") : '', "skip:").concat(skip, ",limit: ").concat(limit);
  var queryOptions = ") {\n            account {\n              account_id\n              first_name\n              last_name\n              full_name\n              uid\n              account_type\n              business_account_type\n              company_name\n              federation_id\n              public_account_id\n              erp_customer_id\n              email_book {\n                is_active\n                email_address\n              }\n            }\n            assets {\n              vehicle {\n                vin\n                last_six_vin\n              }\n            }\n            orders(orderType:[\"ENERGY\",\"VEHICLE\",\"ECOMMERCE\"]) {\n              order_number\n            }\n            contacts {\n              first_name\n              last_name\n              full_name\n              email_book {\n                email_address\n              }\n            }\n            matched_item\n          }\n        }";
  if (filters && (_Object$keys = Object.keys(filters)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
    var _queryOperation;
    // Add filter query operation pram
    queryOperation += ', globalFilters:{and:[';
    // Append filters
    Object.entries(filters).forEach(function (filterOption) {
      var key = filterOption[0];
      var value = filterOption[1];
      queryOperation += "{filterType: \"".concat(key, "\", filterValues: ").concat(JSON.stringify(value), "},");
    });

    // Remove the tailing ','
    if ((_queryOperation = queryOperation) !== null && _queryOperation !== void 0 && _queryOperation.length && queryOperation[queryOperation.length - 1] === ',') {
      queryOperation = queryOperation.slice(0, -1);
    }
    // Close query operation
    queryOperation += ']}';
  }
  return JSON.stringify({
    query: queryOperation + queryOptions,
    variables: {}
  });
};
var navigateUp = function navigateUp(_ref, searchResults) {
  var type = _ref.type,
    item = _ref.item;
  var prevType = type;
  var prevItem = item;

  // initiate to bottom when nothing selected
  if (type === undefined && item === undefined) {
    prevType = searchResults.length - 1;
    prevItem = searchResults[prevType].data.length - 1;
  } else if (item === 0) {
    // switch sections
    if (type !== 0) {
      prevType -= 1;
      prevItem = searchResults[prevType].data.length - 1;
    } else {
      // cycle back to bottom of the list
      prevType = searchResults.length - 1;
      prevItem = searchResults[prevType].data.length - 1;
    }
    // move up
  } else prevItem -= 1;
  return {
    type: prevType,
    item: prevItem
  };
};
var navigateDown = function navigateDown(_ref2, searchResults) {
  var type = _ref2.type,
    item = _ref2.item;
  var nextType = type;
  var nextItem = item;

  // initiate to top  when nothing selected
  if (type === undefined && item === undefined) {
    nextType = 0;
    nextItem = 0;
  } else if (item === searchResults[type].data.length - 1) {
    // switch sections
    if (type !== searchResults.length - 1) {
      nextType += 1;
      nextItem = 0;
    } else {
      // cycle back to top of the list
      nextType = 0;
      nextItem = 0;
    }
    // move down
  } else nextItem += 1;
  return {
    type: nextType,
    item: nextItem
  };
};
var Navigate = {
  up: navigateUp,
  down: navigateDown
};
var capitalizeEachWord = function capitalizeEachWord() {
  var word = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(word).replace(/(\w)(\w*)/g, function (_, g1, g2) {
    return g1.toUpperCase() + g2.toLowerCase();
  });
};

export { Navigate, buildTypeAheadQuery, capitalizeEachWord, debounce, isChina, parseJwt };
